module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.clicked
    }
  }, [_c('div', {
    staticClass: " col-xs-8 col-xs-offset-2 csp-no-pad"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.facebookSigninLoading) ? _c('div', {
    staticClass: "col-xs-2 csp-no-pad"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f1cd040!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/idp/Facebook.vue
// module id = 850
// module chunks = 2